(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('phone-type', {
            parent: 'entity',
            url: '/phone-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-type/phone-types.html',
                    controller: 'PhoneTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('phone-type-detail', {
            parent: 'phone-type',
            url: '/phone-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.phoneType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/phone-type/phone-type-detail.html',
                    controller: 'PhoneTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('phoneType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PhoneType', function($stateParams, PhoneType) {
                    return PhoneType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'phone-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('phone-type-detail.edit', {
            parent: 'phone-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-type.new', {
            parent: 'phone-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('phone-type');
                });
            }]
        })
        .state('phone-type.edit', {
            parent: 'phone-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-dialog.html',
                    controller: 'PhoneTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('phone-type.delete', {
            parent: 'phone-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/phone-type/phone-type-delete-dialog.html',
                    controller: 'PhoneTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PhoneType', function(PhoneType) {
                            return PhoneType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('phone-type', null, { reload: 'phone-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
